import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';

export const fetchGroupsList = () => apiActionCreator({
  'endpoint': '/part-number-code/groups',
  'authenticated': true,
  'types': [
    ActionTypes.FETCH_GROUP_LIST_REQUEST,
    ActionTypes.FETCH_GROUP_LIST_SUCCESS,
    [
      ActionTypes.FETCH_GROUP_LIST_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});
